import React from 'react';

export const Advertisements = () => {
    return(
        <div>
            Page annonces
        </div>
    )
}